import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';

const TasksListPage = lazy(() => import('./TasksListPage'));
const TaskDetailPage = lazy(() => import('./TaskDetailPage'));

export const taskRoutes: RouteObject[] = [
  {
    path: 'tasks',
    element: (
      <ProtectedRoute action="tasks:view">
        <TasksListPage />
      </ProtectedRoute>
    ),
  },
  {
    path: 'tasks/:id',
    element: (
      <ProtectedRoute action="tasks:view">
        <TaskDetailPage />
      </ProtectedRoute>
    ),
  },
];
